import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';

@Component({
    selector: 'app-device-zoom-control',
    templateUrl: './device-zoom-control.component.html',
    styleUrls: ['./device-zoom-control.component.scss'],
    host: {
        '(window:resize)': 'onResize($event)'
    },
    standalone: false
})
export class DeviceZoomControlComponent implements OnInit {
    @ViewChild('zControl') zControl: ElementRef;
    public showControl: boolean = false;
    public DPR: number;
    public zoomPercentage: number;
    public zc: HTMLInputElement;

    constructor(private renderer: Renderer2) {
        this.renderer.listen('window', 'click', (e: Event) => {
            if (this.showControl) {
                if (this.zControl && !this.zControl.nativeElement.contains(e.target)) {
                    this.showControl = false;
                    this.zc.classList.remove('zoom-control-active');
                }
            }
        });
        this.DPR = Math.round(window.devicePixelRatio * 100);
        this.zoomPercentage = Math.round((window.outerWidth / window.innerWidth) * 100);
    }

    ngOnInit() {
        this.zc = document.querySelector<HTMLInputElement>('.zoom-control');
    }

    /**
     * Open Zoom Control box
     */
    openControl() {
        this.DPR = Math.round(window.devicePixelRatio * 100);
        this.zoomPercentage = Math.round((window.outerWidth / window.innerWidth) * 100);
        this.showControl = !this.showControl;
        if (this.zc.classList && !this.zc.classList.contains('zoom-control-active')) {
            this.zc.classList.add('zoom-control-active');
        } else {
            this.zc.classList.remove('zoom-control-active');
        }
    }

    /**
     * Increase Zoom
     */
    increaseZoom() {
        let setWindowZoomLevel = this.detectNextZoomLevel('increase', this.zoomPercentage);
        this.zoomPercentage = setWindowZoomLevel;
        this.setWindowZoomLevel(setWindowZoomLevel);
    }

    /**
     * Increase Zoom
     */
    decreaseZoom() {
        let setWindowZoomLevel = this.detectNextZoomLevel('decrease', this.zoomPercentage);
        this.zoomPercentage = setWindowZoomLevel;
        this.setWindowZoomLevel(setWindowZoomLevel);
    }

    /**
     * Set Zoom Level
     */
    setWindowZoomLevel(zoomPercentage) {
        // @ts-ignore
        document.body.style.zoom = `${zoomPercentage}%`;
    }

    onResize(event) {
        // @ts-ignore
        document.body.style.zoom = '';
        this.DPR = Math.round(window.devicePixelRatio * 100);
        this.zoomPercentage = Math.round((window.outerWidth / window.innerWidth) * 100);
    }

    detectNextZoomLevel(term: string, currentLevel: number) {
        var arr = [25, 33, 50, 67, 75, 80, 90, 100, 110, 125, 150, 175, 200, 250, 300, 400, 500];
        if (term === 'increase') {
            let index = arr.indexOf(currentLevel);
            return arr[index + 1];
        } else if (term === 'decrease') {
            let index = arr.indexOf(currentLevel);
            return arr[index - 1];
        }
        return 25;
    }
}
